


















import { useRoute, defineComponent, ref, useContext } from '@nuxtjs/composition-api';
import type { Route } from 'vue-router';
import PageLoading from '~/components/GlobalComponents/PageLoading.vue';
import Footer from '~/components/solepro/Footer.vue';
import Header from '~/components/solepro/Header.vue';
import { usePageResolver } from '~/stores/page';
import { SOLEPRO_LINKS, SOLEPRO_SCRIPTS, SOLEPRO_TITLE, SOLEPRO_META } from '~/utils/constants/nuxt/metaInfos';
import ClientOnly from 'vue-client-only';

export default defineComponent({
  name: 'SoleproLayout',
  components: {
    PageLoading,
    Header,
    Footer,
    ClientOnly
  },  
  head() {
    const pageParam = ((this.route as Route).query.page && (this.route as Route).query.page !== '0') ? (this.route as Route).query.page : null;
    return {
      titleTemplate: SOLEPRO_TITLE,
      link: [...SOLEPRO_LINKS, { rel: 'canonical', hid: 'canonical', href: `${(this.config as any).soleproDomain}${(this.route as Route).path}${pageParam ? `?page=${pageParam}` : ''}` }],
      script: SOLEPRO_SCRIPTS,
      meta: SOLEPRO_META
    };
  },
  setup() {
    const { app: { $config } } = useContext();
    const route = useRoute();
    const hasBorder = ref(false);

    return {
      route,
      config: $config,
      hasBorder
    };
  },
});
